module.exports = __webpack_public_path__ + "static/img/receipt_3_kuchnia_italia.90718650.jpg";